<template>
  <div v-if="deal" class="container-loan-detail">
    <header class="spaced-header bg-light">
      <b-col class="text-center text-light-blue">
        <b-img src="./static/my_deals/progress_icon.png" fluid alt="Responsive image"></b-img>
        <span class="h3">
          {{ dealGroup | uppercase }} LOANS - DETAIL
        </span>
      </b-col>
    </header>

    <b-row class="pl-5 pr-5">
      <b-col sm="12" xl="4" v-if="activeLoan">
        <loan-active-attributes
          class="mt-sm-3 fix-mobile-height"
          :loan="deal"
          :entity="entity"
        />
      </b-col>
      <b-col md="12" xl="8" v-if="paidLoan" >
        <loan-paid-attributes
          class="mt-sm-3"
          :loan="deal"
          :entity="entity"
        />
      </b-col>
      <b-col md="12" xl="4" v-if="paidLoan" >
        <statements-documents
          v-show="!inProgressDeal()"
          class="mt-xl-3 mt-sm-5 fix-border"
          ref="statementsDocuments"
          :loan="deal"
        />
      </b-col>
      <b-col md="12" xl="8" v-if="pendingLoan" >
        <loan-pending-attributes
          class="mt-sm-3"
          :loan="deal"
          :entity="entity"
        />
      </b-col>
      <b-col sm="12" xl="4" v-if="activeLoan">
        <actions
          class="mt-sm-3"
          ref="docsAssetManager"
          :loan="deal"
          @draw-sent="onDrawSaved"
          @payoff-sent="onPayoffSent"
          @extension-sent="onExtensionSent"
          @ach-payment-sent="onAchPaymentSent"
          @insurance-sent="onInsuranceSent"
          @change-order-sent="onChangeOrderSent"
        />
      </b-col>
      <b-col sm="12" xl="4" v-if="!paidLoan">
        <statements-documents
          v-show="!inProgressDeal()"
          class="mt-3 mt-sm-3"
          ref="statementsDocuments"
          :loan="deal"
        />
        <upload-files
          class="mt-sm-3"
          ref="standardDocumentsUpload"
          :loan="deal"
          @upload-success="updatedMissingIndicators"
          @eor-saved="onEORSaved"
        />
        <files-submited
          class="mt-3 mt-sm-3"
          ref="standardDocuments"
          :loan="deal"
          @upload-success="updatedMissingIndicators"
          @eor-saved="onEORSaved"
        />
      </b-col>
    </b-row>

    <b-row class="contact_order_third mb-4 mt-5 text-left pl-5 pr-5">
      <b-col>
        <b-row>
          <div class="col contact-box" v-if="deal.processor">
            <anchor-contact
              :name="`${deal.processor.first_name} ${deal.processor.last_name}`"
              contactTitle="Loan Account Coordinator"
              :email="deal.processor.email"
              :phone="deal.processor.phone"
              :raised-card="true"
            />
          </div>
          <div class="col contact-box" v-if="deal.lma">
            <anchor-contact
              :name="`${deal.lma.first_name} ${deal.lma.last_name}`"
              contactTitle="Loan Monitoring Associate"
              :email="deal.lma.email"
              :phone="deal.lma.phone"
              :raised-card="true"
            />
          </div>
        </b-row>
        <b-row class="mt-3">
          <div
            class="col contact-box p-1"
            v-for="(item, idx) in this.teamContactCol" v-bind:key="idx"
          >
            <anchor-contact
              :name="item.name"
              :email="item.email"
              :raised-card="true"
            />
          </div>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { DEFINE_MISSING_INDICATORS } from '@/vuex/modules/missing/types/actions';
import AnchorContact from '@/components/utils/AnchorContact';
import LoanPendingAttributes from '@/components/my_deals/deals/LoanPendingAttributes';
import LoanActiveAttributes from '@/components/my_deals/deals/LoanActiveAttributes';
import LoanPaidAttributes from '@/components/my_deals/deals/LoanPaidAttributes';
import LoanButtons from '@/components/my_deals/deals/LoanButtons';
import FilesSubmited from '@/components/my_deals/deals/documents/FilesSubmited';
import Actions from '@/components/my_deals/deals/documents/Actions';
import UploadFiles from '@/components/my_deals/deals/documents/UploadFiles';
import StatementsDocuments from '@/components/my_deals/deals/documents/StatementsDocuments';


export default {
  components: {
    StatementsDocuments,
    LoanActiveAttributes,
    LoanPaidAttributes,
    LoanPendingAttributes,
    AnchorContact,
    LoanButtons,
    Actions,
    FilesSubmited,
    UploadFiles,
  },
  props: {
    action: String,
  },
  data: () => ({
    deal: null,
    actions: {
      standard: ['eor'],
      assetManagement: ['draws', 'change_order', 'payoff', 'extensions', 'achpayment', 'insurance'],
    },
    IN_PROGRESS_CATEGORIES: [
      'unverified',
      'new',
      'need ess',
      'review ess',
      'ess approval',
      'ptd conditions',
      'final approval',
      'needs docs',
      'docs drawn',
      'to be funded',
    ],
    CATEGORIES: {
      active: 'ACTIVE',
      paid: 'PAID',
      in_progress: 'PENDING',
    },
    teamContactCol: [
      {
        name: 'Processing',
        email: 'processing@anchorloans.com',
      },
      {
        name: 'Payments',
        email: 'payments@anchorloans.com',
      },
      {
        name: 'Payoffs',
        email: 'demand@anchorloans.com',
      },
      {
        name: 'Extensions',
        email: 'extensions@anchorloans.com',
      },
      {
        name: 'Draws',
        email: 'draws@anchorloans.com',
      },
    ],
  }),
  computed: {
    dealGroup() {
      return this.CATEGORIES[this.deal.group];
    },
    activeLoan() {
      return this.deal.group === 'active';
    },
    pendingLoan() {
      return this.deal.group === 'in_progress';
    },
    paidLoan() {
      return this.deal.group === 'paid';
    },
    entity() {
      const filteredEntity = this.$store.getters.entities.find(
        entity => entity.id === this.deal.entity_id);
      return filteredEntity;
    },
    neededCount() {
      return this.$store.getters.neededDocumentsCount;
    },
    loansDocsUrl() {
      return `/users/${this.$store.getters.user.id}/loans/${this.$route.params.loan_id}/docs`;
    },
  },
  methods: {
    inProgressDeal() {
      return this.IN_PROGRESS_CATEGORIES.includes(this.deal.loan_category);
    },
    onEORSaved(response) {
      this.$set(this.deal, 'estimate_of_repairs', response.data);
      this.getDocuments();
    },
    onDrawSaved(response) {
      this.$set(this.deal, 'draw_requests', response.data.items);
      this.$set(this.deal.documents.asset_management, 'draws', response.data.docs);
      this.getDocuments();
    },
    onPayoffSent(response) {
      this.$set(this.deal, 'payoff_requests', response.data.items);
      this.$set(this.deal.documents.asset_management, 'payoff', response.data.docs);
      this.getDocuments();
    },
    onExtensionSent(response) {
      this.$set(this.deal.documents.asset_management, 'extensions', response.data.docs);
      this.getDocuments();
    },
    onAchPaymentSent(response) {
      this.$set(this.deal, 'achpayment', response.data.items);
      this.$set(this.deal.documents.asset_management, 'achpayment', response.data.docs);
      this.getDocuments();
    },
    onInsuranceSent(response) {
      this.$set(this.deal, 'insurance', response.data.items);
      this.$set(this.deal.documents.asset_management, 'insurance', response.data.docs);
      this.getDocuments();
    },
    onChangeOrderSent(response) {
      this.$set(this.deal.documents.asset_management, 'change_order', response.data.docs);
      this.getDocuments();
    },
    updatedMissingIndicators() {
      const config = { pre: false, post: false, error: false };
      this.$reqs
        .get(`/users/${this.$store.getters.user.id}/indicators`, null, config)
        .then((response) => {
          this.$store.dispatch(DEFINE_MISSING_INDICATORS, { missing: response.data });
        })
        .catch(() => {});
      this.getDocuments();
    },
    getDocuments() {
      this.$reqs
        .get(`${this.loansDocsUrl}/type/all`)
        .then((response) => {
          this.deal.documents = response.data;
        })
        .catch(() => {});
    },
  },
  mounted() {
    const url = `/users/${this.$store.getters.user.id}/loans/${this.$route.params.loan_id}`;
    this.$reqs.get(url)
      .then((response) => {
        this.deal = response.data;
        if (this.action) {
          this.$nextTick(() => {
            if (this.actions.standard.includes(this.action)) {
              this.$refs.standardDocuments.showEORModal();
            } else if (this.actions.assetManagement.includes(this.action)) {
              this.$refs.docsAssetManager.show(this.action);
            }
          });
        }
      })
      .catch(() => {
      });
  },
};
</script>

<style>
.container-loan-detail {
  display: flex;
  flex-direction: column;
}
.contact-box {
  display: block;
}
@media (min-width: 1333px) {
  .contact-box {
    max-width: 100%;
  }
}
@media (min-width: 1333px) {
  .fix-border {
    height: 96.6% !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/my_deals/deals/DealDetail.vue